module.exports = __webpack_public_path__ + "img/caseai1.479322a0.png";